const es = global.es; // TODO Remove dependency!!!

export default class BoundsUtil {
    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    sanitize(bounds: number[]): number[] {
        if (bounds[0] > bounds[2]) {
            const tmp = bounds[0];
            bounds[0] = bounds[2];
            bounds[2] = tmp;
        }

        if (bounds[1] > bounds[3]) {
            const tmp = bounds[1];
            bounds[1] = bounds[3];
            bounds[3] = tmp;
        }

        return bounds;
    }
    
    /**
     * 
     * @param boundsA 
     * @param boundsB 
     * 
     * @returns 
     */
    intersect(boundsA: number[], boundsB: number[]): boolean {
        if (boundsA == null || boundsA == undefined || boundsB == null || boundsB == undefined) {
            es.log.error('Invalid bounds! boundsA [' + boundsA + '] boundsB [' + boundsB + ']');
        }

        if ((boundsA[0] < boundsB[2]) && (boundsA[2] > boundsB[0]) && (boundsA[1] < boundsB[3]) && (boundsA[3] > boundsB[1])) {
            return true;
        }
        
        if ((boundsB[0] === boundsB[2]) || (boundsB[1] === boundsB[3])) {
            return (boundsA[0] <= boundsB[0]) && (boundsA[1] <= boundsB[1]) && (boundsA[2] >= boundsB[0]) && (boundsA[3] >= boundsB[1]);
        }
        
        if ((boundsA[0] === boundsA[2]) || (boundsA[1] === boundsA[3])) {
            return (boundsB[0] <= boundsA[0]) && (boundsB[1] <= boundsA[1]) && (boundsB[2] >= boundsA[0]) && (boundsB[3] >= boundsA[3]);
        }
        
        return false;   
    }
    
    /**
     * 
     * @param bounds 
     * @param point 
     * 
     * @returns 
     */
    containsPoint(bounds: number[], point: number[]): boolean {
        return ((bounds[0] <= point[0]) && (bounds[1] <= point[1]) && (bounds[2] >= point[0]) && (bounds[3] >= point[1]));
    }
    
    /**
     * 
     * @param boundsA 
     * @param boundsB 
     * 
     * @returns 
     */
    contains(boundsA: number[], boundsB: number[]): boolean {
        return ((boundsA[0] <= boundsB[0])
                && (boundsA[1] <= boundsB[1])
                && (boundsA[2] >= boundsB[2])
                && (boundsA[3] >= boundsB[3]));
    }
    
    /**
     * 
     * @param boundsA 
     * @param boundsB 
     * 
     * @returns 
     */
    equal(boundsA: number[], boundsB: number[]): boolean {
        return ((boundsA[0] === boundsB[0])
                && (boundsA[1] === boundsB[1])
                && (boundsA[2] === boundsB[2])
                && (boundsA[3] === boundsB[3]));
    }
    
    /**
     * 
     * @param boundsA 
     * @param boundsB 
     * 
     * @returns 
     */
    intersection(boundsA: number[], boundsB: number[]): number[] | null {
        const intersection = [
            Math.max(boundsA[0], boundsB[0]),
            Math.max(boundsA[1], boundsB[1]),
            Math.min(boundsA[2], boundsB[2]),
            Math.min(boundsA[3], boundsB[3])
        ];
        
        this.sanitize(intersection);
        
        if (this.contains(boundsA, intersection)) {
            if ((intersection[0] === intersection[2] || intersection[1] === intersection[3])
                && !this.equal(intersection, boundsA)
                && !this.equal(intersection, boundsB)) {
                return null;
            }

            return intersection;
        }
        
        return null;
    }
    
    /**
     * 
     * @param boundsA 
     * @param boundsB 
     * @param result 
     * 
     * @returns 
     */
    union(boundsA: number[], boundsB: number[], result?: number[]): number[] {
        if (!result) {
            result = [];
        }

        result[0] = Math.min(boundsA[0],boundsB[0]);
        result[1] = Math.min(boundsA[1],boundsB[1]);
        result[2] = Math.max(boundsA[2],boundsB[2]);
        result[3] = Math.max(boundsA[3],boundsB[3]);

        return result;
    }
    
    /**
     * 
     * @param toCut 
     * @param cutAround 
     * @param results 
     */
    cut(toCut: number[], cutAround: number[], results: number[][]) {
        if (this.intersect(toCut, cutAround)) {
            if ((cutAround[0] > toCut[0]) && (cutAround[0] < toCut[2])) {
                this.cut([toCut[0], toCut[1], cutAround[0], toCut[3]], cutAround, results);
                this.cut([cutAround[0], toCut[1], toCut[2], toCut[3]], cutAround, results);
            } else if ((cutAround[2] > toCut[0]) && (cutAround[2] < toCut[2])) {
                this.cut([toCut[0], toCut[1], cutAround[2], toCut[3]], cutAround, results);
                this.cut([cutAround[2], toCut[1], toCut[2], toCut[3]], cutAround, results);
            } else if ((cutAround[1] > toCut[1]) && (cutAround[1] < toCut[3])) {
                this.cut([toCut[0], toCut[1], toCut[2], cutAround[1]], cutAround, results);
                this.cut([toCut[0], cutAround[1], toCut[2], toCut[3]], cutAround, results);
            } else if ((cutAround[3] > toCut[1]) && (cutAround[3] < toCut[3])) {
                results.push([toCut[0], toCut[1], toCut[2], cutAround[3]]);
                results.push([toCut[0], cutAround[3], toCut[2], toCut[3]]);
            } else {
                results.push(toCut);
            }
        } else {
            results.push(toCut);
        }
    }
    
    /**
     * 
     * @param vectors 
     * @param bounds 
     * @param startIndex 
     * @param endIndex 
     * 
     * @returns 
     */
    valueOf(vectors: number[], bounds?: number[], startIndex?: number, endIndex?: number): number[] {
        if (!bounds) {
            bounds = [Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE];
        }

        if (startIndex == null) {
            startIndex = 0;
        }

        if (endIndex == null) {
            endIndex = vectors.length;
        }

        while (startIndex < endIndex) {
            bounds[0] = Math.min(bounds[0], vectors[startIndex]);
            bounds[2] = Math.max(bounds[2], vectors[startIndex++]);
            bounds[1] = Math.min(bounds[1], vectors[startIndex]);
            bounds[3] = Math.max(bounds[3], vectors[startIndex++]);
        }

        return bounds;
    }
    
    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    toGeom(bounds: number[]): any[] {
        return ["PN",[
            bounds[0],bounds[1],
            bounds[0],bounds[3],
            bounds[2],bounds[3],
            bounds[2],bounds[1],
            bounds[0],bounds[1]
        ]];
    }
    
    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    getCenterPoint(bounds: number[]): number[] {
        const sanitized = this.sanitize(bounds);
        return [(sanitized[0] + sanitized[2]) / 2, (sanitized[1] + sanitized[3]) / 2];
    }
    
    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    area(bounds: number[]): number {
        return bounds ? Math.abs((bounds[2]-bounds[0])*(bounds[3]-bounds[1])) : 0;
    }
    
    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    isEmpty(bounds: number[]): boolean {
        return this.equal([Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE], bounds);
    }

    /**
     * 
     * @param bounds 
     * 
     * @returns 
     */
    isAllZero(bounds: number[]): boolean {
        return this.equal([0, 0, 0, 0], bounds);
    }

    /**
     * 
     * @param bounds 
     * @param point 
     * 
     * @returns 
     */
    addPoint(bounds: number[], point: number[]): number[] {
        return this.union(bounds, [point[0], point[1], point[0], point[1]]);
    }
    
    /**
     * 
     * @param bounds 
     * @param amt 
     * 
     * @returns 
     */
    bufferBy(bounds: number[], amt: number): number[] {
        const ret = this.sanitize(bounds);
        ret[0] -= amt;
        ret[1] -= amt;
        ret[2] += amt;
        ret[3] += amt;

        return ret;
    }
    
    touch(boundsA: number[], boundsB: number[]): boolean {
        if (!(
            ((boundsA[2] < boundsB[0])
             || (boundsA[3] < boundsB[1])
             || (boundsA[0] > boundsB[2])
             || (boundsA[1] > boundsB[3])
            ))) { // ranges do not interract
            const innerMinX = Math.max(boundsB[0], boundsA[0]);
            const innerMinY = Math.max(boundsB[1], boundsA[1]);
            const innerMaxX = Math.min(boundsB[2], boundsA[2]);
            const innerMaxY = Math.min(boundsB[3], boundsA[3]);
            
            if ((innerMinX === boundsA[0])
                || (innerMinX === boundsA[2])
                || (innerMinY === boundsA[1])
                || (innerMinY === boundsA[3])
                || (innerMaxX === boundsA[0])
                || (innerMaxX === boundsA[2])
                || (innerMaxY === boundsA[1])
                || (innerMaxY === boundsA[3])) {
                return (innerMinX === boundsB[0])
                        || (innerMinX === boundsB[2])
                        || (innerMinY === boundsB[1])
                        || (innerMinY === boundsB[3])
                        || (innerMaxX === boundsB[0])
                        || (innerMaxX === boundsB[2])
                        || (innerMaxY === boundsB[1])
                        || (innerMaxY === boundsB[3]);
            }
        }

        return false;
    }

    /**
     * @param bounds
     * 
     * @returns
     */
    isBoundsSinglePoint(bounds: number[]): boolean {
        return (bounds[0] === bounds[2]) && (bounds[1] === bounds[3]);
    }

    /**
     * Get bounds for any array of unrelated points (a 'cloud' of points) e.g.:
     *     const bnds = es.util.bounds.forPoints( [ [-78.6799, 43.9248], [18.6304, -34.0518], [3.6061, 50.7459] ] );
     *     esApp.map.overlay.drawBounds(bnds, null, 5000);
     * 
     * @param points
     * 
     * @returns 
     */
    forPoints(points: number[][]): number[] {
        let bounds = [Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE];

        points.forEach(point => {
            bounds = this.addPoint(bounds, [point[0], point[1]]);
        });

        return bounds;
    }
}
